<template>
    <tabbed-menu :initial-tab="defaultTab"
        :tabs="[{
                name: tabs.traffic,
                label: resource('TouchpointStatistics_Traffic_Tab_Header')
            }, {
                name: tabs.other,
                label: resource('TouchpointStatistics_Other_Tab_Header')
            }]"
        :subMenu="isSubMenu"
    >
        
        <template :slot="tabs.traffic">
            <statistics-traffic
                class="tab-pane show active"
                role="tabpanel"

                :brick-id="brickId"
            />
        </template>
        
        <template :slot="tabs.other">
            <statistics-other
                class="tab-pane show active"
                role="tabpanel"

                :brick-id="brickId"
            />
        </template>

    </tabbed-menu>
</template>

<script>
    import resources from "@core/Util/Mixins/resources";
    
    import TabbedMenu from '@core/Components/Navigation/TabbedMenu.vue';
    import StatisticsTraffic from './TouchpointStatisticsTraffic.vue';
    import StatisticsOther from './TouchpointStatisticsOther.vue';
    
    const tabs = {
        traffic: 'traffic',
        other: 'other'
    };
    
    const defaultTab = tabs.traffic;

    export default {
        name: 'touchpoint-statistics',
        mixins: [resources],
        components: {
            StatisticsTraffic,
            StatisticsOther,
            TabbedMenu
        },
        data: () => ({ tabs, defaultTab }),
        props: {
            isSubMenu: {
                type: Boolean,
                required: false,
                default: true
            },
            brickId: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/touchpoint-statistics.scss";
</style>
